import { safetyContent } from "@/mocks/content";

export default function SafetySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Safety &amp; Trust
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            {safetyContent.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {safetyContent.intro}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-14">
          {safetyContent.tips.map((tip, i) => (
            <div
              key={i}
              className="flex gap-4 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/60"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${tip.icon} text-lg md:text-xl text-secondary-600`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                  {tip.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {tip.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="overflow-x-auto rounded-2xl border border-background-200/60">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-secondary-100/60">
                  <th className="text-left py-3.5 px-5 text-sm font-semibold text-foreground-800 rounded-tl-2xl">
                    <i className="ri-alert-line mr-1.5"></i> Potential Risk
                  </th>
                  <th className="text-left py-3.5 px-5 text-sm font-semibold text-foreground-800 rounded-tr-2xl">
                    <i className="ri-shield-check-line mr-1.5"></i> Protection Method
                  </th>
                </tr>
              </thead>
              <tbody>
                {safetyContent.safetyTable.map((row, i) => (
                  <tr key={i} className="border-t border-background-200/40 hover:bg-background-50 transition-colors">
                    <td className="py-3 px-5 text-sm text-foreground-700">{row.risk}</td>
                    <td className="py-3 px-5 text-sm text-secondary-700 font-medium">{row.protection}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}